import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isAdmin, loading, logout } = useAuth();

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f7fafc'
            }}>
                <p style={{ color: '#718096' }}>Loading...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }

    if (!isAdmin || !localStorage.getItem('admin_token')) {
        logout();
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
